<template>
  <div>
    <v-app class="p-4">
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              transition="dialog-bottom-transition"
              max-width="700px"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title> ویرایش تعرفه</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-card-text>
                <v-row class="mt-5">
                  <v-col cols="12" md="6">
                    <v-autocomplete
                        :items="tarefeList"
                        label="نوع تعرفه"
                        required
                        dense
                        item-text="name"
                        :value="updatedDatas.type"
                        v-model="updatedDatas.type"
                        outlined
                        class="mt-1"
                        prepend-inner-icon="fa fa-pencil-alt"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                        v-model="updatedDatas.title"
                        label="عنوان تعرفه"
                        required
                        dense
                        outlined
                        class="mt-1"
                        prepend-inner-icon="fa fa-pencil-alt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                        v-model.number="updatedDatas.price"
                        label="قیمت تعرفه"
                        outlined
                        required
                        dense
                        type="number"
                        prepend-inner-icon="fa fa-pencil-alt"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-btn class="btn-update text-white float-left" @click="updateData(updatedDatas.id)">
                  <span class="material-icons">save</span>
                  ثبت به روز رسانی
                </v-btn>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="error" @click="editModal = false; updatedDatas=[]">
                  بستن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <router-link to="/admin/tarefe/otherTarefe/add">
            <v-btn class="btn-add-with-text mt-5">
              <span class="fa fa-plus ml-1"></span>
              ایجاد تعرفه جدید
            </v-btn>
          </router-link>

          <v-card :loading="loading" class="p-3 pt-0">
            <data-table
                :data="datas"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :orderBy="tableProps.column"
                :pagination="paginate"
                :orderDir="tableProps.dir"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search; reloadTable() }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import Swal from "sweetalert2";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "showTarefeList",
  components: {FiltersTable, TitleRibbon, button, dataTableProps, createTarefe},
  data() {
    return {
      editModal: false,
      loading: false,
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/admin/packs/other`,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'نوع تعرفه',
          name: 'type',
          transform: (val) => {
            return `<span class="badge badge-primary">${this.tarefeList.find((x) => x.value === val.data.type).name}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'قیمت',
          name: 'price',
          transform: (val) => {
            return val.data.price ? val.data.price : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'admin_other_pack_update'

              },
              {
                name: 'delete',
                label: 'حذف تعرفه',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'admin_other_pack_destroy'
              },
            ]
          }
        }
      ],
      updatedDatas: [],
      tarefeList: [
        {
          name: 'تعرفه چت', value: 'chat',
        },
        {
          name: 'تعرفه تازه های دیوار', value: 'new',
        },
        {
          name: 'تعرفه مترادف', value: 'unique',
        },
        {
          name: 'تعرفه حمله', value: 'report',
        },
      ],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    updateData: function (value) {
      $.ajax({
        url: `${url}/admin/packs/other/${value}`,
        type: 'PUT',
        fn: this.updateData,
        params: [value],
        headers: {
          'Authorization': Token,
          ACCEPT: 'application/json',
          "content-Type": 'application/json'
        },
        data: JSON.stringify(this.updatedDatas),
        msg: true,
        statusCode: {
          202: (res) => {
            this.reloadTable();
            this.editModal = false;
          }
        }
      })
    },
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false;
        }
      }).catch(() => {
        vm.loading = false;
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    actions(data, type) {
      const vm = this
      if (type === 'edit') {
        vm.editModal = true;
        vm.updatedDatas = {
          id: data.id,
          title: data.title,
          price: data.price,
          type: data.type,
        };


      } else if (type === 'delete') {

        this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
          if (value === true) {
            $.ajax({
              url: `${url}/admin/packs/other/${data.id}`,
              type: 'DELETE',
              fn: this.actions,
              params: [data, type],
              headers: {
                'Authorization': Token,
                ACCEPT: 'application/json',
              },
              msg: true,
            })
          }
        }))
      }
    },
  },
  watch:{
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
        this.reloadTable();
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url);
    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
  },
}
</script>

<style scoped>

</style>